import React from "react";
import { FaShieldAlt } from "react-icons/fa";
import { MdOutlineReviews } from "react-icons/md";
import { RiEarthFill } from "react-icons/ri";

const items = [
  {
    icon: <RiEarthFill size={32} />,
    title: "300,000+ Experiences",
    desc: "Find unforgettable things to do across the globe",
  },
  {
    icon: <MdOutlineReviews size={32} />,
    title: "Trusted Reviews",
    desc: "Thousands of verified reviews from real travelers",
  },
  {
    icon: <FaShieldAlt size={32} />,
    title: "Security Assurance",
    desc: "Book with confidence & safe transactions",
  },
];

// Soft blob background SVG
const BlobBg = ({ children }) => (
  <div className="relative w-[90px] h-[90px] flex items-center justify-center">
    <svg
      width="90"
      height="90"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute top-0 left-0"
    >
      <path
        fill="#E8FAFF"
        d="M41.3,-57.5C55.3,-50.7,68.3,-37.8,73.2,-22.6C78.2,-7.5,75.2,10,67.1,22.7C59.1,35.3,46,43.1,32.6,52.1C19.2,61.2,9.6,71.5,-2.2,75.3C-14.1,79.1,-28.1,76.4,-41.1,69.3C-54,62.2,-66,50.7,-72.5,36.3C-78.9,21.9,-79.8,4.6,-75.5,-11.8C-71.1,-28.2,-61.5,-43.7,-48.3,-50.9C-35,-58.1,-18,-57.1,-1.6,-55.1C14.8,-53,29.6,-50.2,41.3,-57.5Z"
        transform="translate(100 100)"
      />
    </svg>

    <div className="relative text-[#00C3CC]">{children}</div>
  </div>
);

export default function BookYourAdventure() {
  return (
    <div className="py-20">
      <h2 className="text-center text-[#000000] font-bold text-2xl md:text-3xl">
        Book Your Next Adventure
      </h2>
      <p className="text-center text-[16px] md:text-lg text-[#242424] pt-1 md:pt-3">
        Find the perfect experience for you and your loved ones
      </p>
      <div className="mt-3 h-1 w-[40%] md:w-[20%] lg:w-[11%] bg-[#1FADC6] mx-auto"></div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center gap-3 px-6"
          >
            {/* Icon with blob background */}
            <BlobBg>{item.icon}</BlobBg>

            <h3 className="font-semibold text-gray-900 text-lg">
              {item.title}
            </h3>
            <p className="text-gray-500 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
